"use client";

import { signIn } from "next-auth/react";
import Link from "next/link";
import { ComponentProps, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { twMerge } from "tailwind-merge";

import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";

import { GoogleIcon } from "ui/icon/social";

export const GoogleLoginButton = ({
  callbackUrl,
  ...props
}: ComponentProps<"button"> & { callbackUrl?: string }) => {
  const { t, lang } = useLang();
  const [isWebView, setIsWebView] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isWebView = userAgent.includes("line");
    setIsWebView(isWebView);
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <button
        {...props}
        className={twMerge(
          "flex h-11 items-center justify-center gap-2 rounded-md border border-neutral-400 text-sm hover:bg-slate-50 active:bg-slate-100",
          props.className
        )}
        onClick={async () => {
          try {
            await signIn("google", {
              redirect: true,
              callbackUrl: callbackUrl ?? `/${lang}${links.myAnalysisSearch}`,
            });
          } catch {
            toast.error(t.error.serverError);
          }
        }}
      >
        <GoogleIcon className="h-5 w-5" />
        {props.children}
      </button>
      {isWebView && (
        <Link
          className="text-xs text-neutral-500"
          href={
            "https://developers.line.biz/en/faq/tags/line-app/#social-login-with-google-does-not-work-in-the-liff-browser-or-lines-in-app-browser"
          }
        >
          {t.auth.login.openExternalBrowser}
        </Link>
      )}
    </div>
  );
};
